export default __webpack_public_path__ + "static/media/arbitrum_mask.83666523.svg";